import { sqLayoutStore } from '@/core/core.stores';

export function setAssetGroupEditorVisible(visible: boolean) {
  sqLayoutStore.actions.setAssetGroupEditorVisible(visible);
}

export function setTableDefinitionEditorVisible(visible: boolean) {
  sqLayoutStore.actions.setTableDefinitionEditorVisible(visible);
}

export function setStoredTableEditorVisible(visible: boolean) {
  sqLayoutStore.actions.setStoredTableEditorVisible(visible);
}

export function setDisplayPaneAddOnCapsulePanelEnabled(enabled: boolean) {
  sqLayoutStore.actions.setDisplayPaneAddOnCapsulePanelEnabled(enabled);
}

export function setDisplayPaneAddOnDetailsPanelEnabled(enabled: boolean) {
  sqLayoutStore.actions.setDisplayPaneAddOnDetailsPanelEnabled(enabled);
}

export function setTrendVisible(visible: boolean) {
  sqLayoutStore.actions.setTrendVisible(visible);
}

export function setAutoFocusToolsTab(autofocus: boolean) {
  sqLayoutStore.actions.setAutoFocusToolsTab(autofocus);
}

export function setAutoFocusDataTab(autofocus: boolean) {
  sqLayoutStore.actions.setAutoFocusDataTab(autofocus);
}

export function resetLayout(reset: boolean) {
  sqLayoutStore.actions.resetLayout(reset);
}
export function resetJournalToolbar(reset: boolean) {
  sqLayoutStore.actions.resetJournalToolbar(reset);
}

export function setJournalTabVisible(visible: boolean) {
  sqLayoutStore.actions.setJournalTabVisible(visible);
}

export function setFormulaInTab(inTab: boolean) {
  sqLayoutStore.actions.setFormulaInTab(inTab);
}
export function setFormulaTabAnchorPosition({
  top,
  left,
  height,
  width,
}: {
  top: number;
  left: number;
  height: number;
  width: number;
}) {
  sqLayoutStore.actions.setFormulaTabAnchorPosition({ top, left, height, width });
}
export function setAutoFocusTrendTab(autofocus: boolean) {
  sqLayoutStore.actions.setAutoFocusTrendTab(autofocus);
}

export function setAutoFocusTableDefinitionTab(autofocus: boolean) {
  sqLayoutStore.actions.setAutoFocusTableDefinitionTab(autofocus);
}

export function setAutoFocusStoredTableTab(autofocus: boolean) {
  sqLayoutStore.actions.setAutoFocusStoredTableTab(autofocus);
}

export function setStatisticsSummaryTabVisible(visible: boolean) {
  sqLayoutStore.actions.setStatisticsSummaryTabVisible(visible);
}
